export const SIDEBAR_WIDTH = '200';
